import { EMapBoundsActionType } from './types';
import { TMapBounds } from '../../types/mapBounds';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export const changeBounds = actionGenerator<EMapBoundsActionType.Changed, TMapBounds>(EMapBoundsActionType.Changed);
